import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { consultarHistoricoUsuariosIfService } from '../../Service/consultar-historico-usuarios-if.service';
import { UserService } from 'src/app/services/user.service';
declare var $:any;

@Component({
    selector: 'app-consultar-historico-usuarios-if',
    templateUrl: './consultar-historico-usuarios-if.component.html',
    styleUrls: ['./consultar-historico-usuarios-if.component.scss'],
    providers: [
        consultarHistoricoUsuariosIfService
    ],
    standalone: false
})
export class ConsultarHistoricoUsuariosIFComponent implements OnInit {
  consulHistoUsuaForm: UntypedFormGroup;
  mostrarForm: UntypedFormGroup;
  documentos: any[] = [];
  totalPaginas: number = 1;
  paginaActual: number = 0;
  listaClientes: any [] = [];
  listaUsuarios: any[] = [];
  historicoUsuario: any[] = [];
  usuario: any;
  idCliente: any;
  public datosTabla: boolean = false;
  public datosUsuario: boolean = true;

  constructor(private consultarHistoricoUsuariosIfService : consultarHistoricoUsuariosIfService,
    private formBuilder: UntypedFormBuilder,    
    private user: UserService,) {
      this.consulHistoUsuaForm = this.formBuilder.group({
        idTipoDocIdentidad_NeoTipoDocIdentidad: null,
        numeroDocumento: null,
        estado: null,
        pagina: 1
      })
      this.mostrarForm = this.formBuilder.group({
        nombre: null
      })
     }

  ngOnInit() {
    this.getDocumentos();  
    this.loadSelectPiker();
    this.datosUsuario = true;
    this.idCliente = this.user.getUser().idCliente;
  }

  getDocumentos(){
    this.consultarHistoricoUsuariosIfService.getTipoDocumentos().subscribe((data:any)=>{
      this.documentos = data.filter(
        (documento) => documento.personaJuridica != 1 && documento.idTipoDocIdentidad != 4 && documento.idTipoDocIdentidad != 6
      );
    })
  }

  loadSelectPiker() {
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    });
  }
  
  consultaHistorico(){
    if(this.consulHistoUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value!=null){
      this.consulHistoUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad')
      .setValue(Number(this.consulHistoUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value));
    }
    if(this.consulHistoUsuaForm.get('numeroDocumento').value==''){
      this.consulHistoUsuaForm.get('numeroDocumento').setValue(null);
    }  
    const body:any = {
      idTipoDocIdentidad_NeoTipoDocIdentidad: this.consulHistoUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value,
      numeroDocumento: this.consulHistoUsuaForm.get('numeroDocumento').value,
      idCliente: this.idCliente,
      isGetBloqueados: 0,
      estado: this.consulHistoUsuaForm.get('estado').value,
      pagina: this.consulHistoUsuaForm.get('pagina').value
    }
    this.consultarHistoricoUsuariosIfService.getConsultarHistorial(body).subscribe((response:any)=>{
      this.listaUsuarios = response.data;
      if(this.listaUsuarios==undefined){
        this.datosTabla = false;
        this.mensaje();
      }else{
        this.datosTabla = true;
        this.totalPaginas = response.paginasTotales;
        this.paginaActual = response.paginaActual;
      }
    })
  }

  mensaje(){
    $('#mensajeModal').modal('show');    
  }

  verHistorico(i){
    const body:any = {
      idUsuario: this.listaUsuarios[i].idUsuario,
      pagina: this.consulHistoUsuaForm.get('pagina').value
    }    
    this.consultarHistoricoUsuariosIfService.getModificarHistorial(body).subscribe((response:any)=>{
      this.usuario = response;
      this.historicoUsuario = response.data;
      this.mostrarForm.get('nombre').setValue(this.historicoUsuario[0].usuario);
      this.datosUsuario = false;      
      this.totalPaginas = response.paginasTotales;
      this.paginaActual = response.paginaActual;
    })
  }

  descargarExcelUsuario(){    
    const body:any ={
      idTipoDocIdentidad_NeoTipoDocIdentidad: null,
      numeroDocumento: null,
      idUsuario: this.usuario.idUsuario,
      idCliente: this.idCliente,
      isGetBloqueados: 0,
      isExcel: true,
      isHistoricoUsuario: true,
      estado: null,
      pagina: this.consulHistoUsuaForm.get('pagina').value
    }
    this.consultarHistoricoUsuariosIfService.dowloadConsultaHistoricosUsuarios(body).subscribe((response:any) =>{
      if(response.exitoso == true){
        var a = document.getElementById('downloadFile');
        a.setAttribute('href', `data:${response.mimeType};base64,${response.data}`);
        a.setAttribute('download', unescape(response.fileName));
        a.click();
      }     
    })
  }

  descargarTxtUsuario(){
    const body:any ={
      idTipoDocIdentidad_NeoTipoDocIdentidad: null,
      numeroDocumento: null,
      idUsuario: this.usuario.idUsuario,
      idCliente: this.idCliente,
      isGetBloqueados: 0,
      isExcel: false,
      isHistoricoUsuario: true,
      estado: null,
      pagina: this.consulHistoUsuaForm.get('pagina').value
    }
    this.consultarHistoricoUsuariosIfService.dowloadConsultaHistoricosUsuarios(body).subscribe((response:any) =>{
      if(response.exitoso == true){
        var a = document.getElementById('downloadFile');
        a.setAttribute('href', `data:${response.mimeType};base64,${response.data}`);
        a.setAttribute('download', unescape(response.fileName));
        a.click();
      }     
    })
  }

  descargarExcel(){
    if(this.consulHistoUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value!=null){
      this.consulHistoUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad')
      .setValue(Number(this.consulHistoUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value));
    }
    if(this.consulHistoUsuaForm.get('numeroDocumento').value==''){
      this.consulHistoUsuaForm.get('numeroDocumento').setValue(null);
    }    
    const body:any ={
      idTipoDocIdentidad_NeoTipoDocIdentidad: this.consulHistoUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value,
      numeroDocumento: this.consulHistoUsuaForm.get('numeroDocumento').value,
      idUsuario: null,
      idCliente: this.idCliente,
      isGetBloqueados: 0,
      isExcel: true,
      isHistoricoUsuario: false,
      estado: this.consulHistoUsuaForm.get('estado').value,
      pagina: this.consulHistoUsuaForm.get('pagina').value
    }
    this.consultarHistoricoUsuariosIfService.dowloadConsultaHistoricosUsuarios(body).subscribe((response:any) =>{
      if(response.exitoso == true){
        var a = document.getElementById('downloadFile');
        a.setAttribute('href', `data:${response.mimeType};base64,${response.data}`);
        a.setAttribute('download', unescape(response.fileName));
        a.click();
      }     
    })
  }

  descargarTxt(){
    if(this.consulHistoUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value!=null){
      this.consulHistoUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad')
      .setValue(Number(this.consulHistoUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value));
    }
    if(this.consulHistoUsuaForm.get('numeroDocumento').value==''){
      this.consulHistoUsuaForm.get('numeroDocumento').setValue(null);
    } 
    const body:any ={
      idTipoDocIdentidad_NeoTipoDocIdentidad: this.consulHistoUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value,
      numeroDocumento: this.consulHistoUsuaForm.get('numeroDocumento').value,
      idUsuario: null,
      idCliente: this.idCliente,
      isGetBloqueados: 0,
      isExcel: false,
      isHistoricoUsuario: false,
      estado:  this.consulHistoUsuaForm.get('estado').value,
      pagina: this.consulHistoUsuaForm.get('pagina').value
    }
    this.consultarHistoricoUsuariosIfService.dowloadConsultaHistoricosUsuarios(body).subscribe((response:any) =>{
      if(response.exitoso == true){
        var a = document.getElementById('downloadFile');
        a.setAttribute('href', `data:${response.mimeType};base64,${response.data}`);
        a.setAttribute('download', unescape(response.fileName));
        a.click();
      }     
    })
  }

  selectPage(pageNumber: number){
    this.consulHistoUsuaForm.get('pagina').setValue(pageNumber);
    this.consultaHistorico();
  }

  validateNumber(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  validateDocument(event: any) {
    if (this.consulHistoUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value == 5 ||
    this.consulHistoUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value == 3) {
      const pattern = /[a-zA-Z0-9]/;
      let inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    } else {
      this.validateNumber(event);
    }
  }
  validarSelect() {
    this.consulHistoUsuaForm.get('numeroDocumento').setValue('');
  }


}
